/**
 * DiseaseOptionCard - Multi-select card for disease priorities
 *
 * A selectable card component for the feedback step.
 */

interface DiseaseOptionCardProps {
  label: string;
  isSelected: boolean;
  onToggle: () => void;
}

export function DiseaseOptionCard({
  label,
  isSelected,
  onToggle,
}: DiseaseOptionCardProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`flex w-full items-center justify-between rounded-2xl px-4 py-4 text-left transition-all ${
        isSelected
          ? 'multi-disease-card-selected'
          : 'multi-disease-card'
      }`}
    >
      <span className="text-sm font-medium text-catch-dark-blue-90">{label}</span>

      {/* Checkbox indicator */}
      <div
        className={`flex h-6 w-6 items-center justify-center rounded-md border-2 transition-all ${
          isSelected
            ? 'border-catch-teal bg-catch-teal'
            : 'border-gray-300 bg-white'
        }`}
      >
        {isSelected && (
          <svg
            className="h-4 w-4 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={3}
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
      </div>
    </button>
  );
}

export default DiseaseOptionCard;
